import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=216d3232&"
import script from "./BookingDetails.vue?vue&type=script&lang=ts&"
export * from "./BookingDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BookingDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports